/**
 * @module api/exclusiveApi/exclusiveQrisApi
 */

import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';

const PREFIX_URL = `${exclusiveUrl}/mitra-qr`;

/**
 * Retrieve user info
 *
 * https://blueprint.bukalapak.io/exclusive/t/mitra-single-qr~mitra~single~qr~get~exclusive~mitra-qr~qris
 */
function retrieveUserInfo() {
  return this.get(`${PREFIX_URL}/qris`, 'user');
}

/**
 * Retrieve Device Info
 *
 * https://blueprint.bukalapak.io/exclusive/t/mitra~single~qr~mitra~single~qr~get~exclusive~mitra-qr~merchants~soundbox-device
 */
function retrieveDeviceInfo() {
  return this.get(`${PREFIX_URL}/merchants/soundbox-device`, 'user', {
    responseErrorJson: true,
  });
}

/**
 * Retrieve Kirim Uang transaction monthly summaries
 * https://blueprint.bukalapak.io/exclusive/t/mitra~single~qr~mitra~single~qr~get~exclusive~mitra-qr~qris~transactions~soundbox-devices~summaries
 */
function retrieveQrisSoundBoxTransactionSummaries({
  number_of_months: numberOfMonths,
}) {
  return this.get(
    `${PREFIX_URL}/qris/transactions/soundbox-devices/summaries?number_of_months=${numberOfMonths}`,
  );
}

/**
 * Retrieve QRIS soundbox paid payment list and additional info.
 */
function retrieveQrisSoundBoxPayments({ status, offset, limit }) {
  return this.get(
    `${PREFIX_URL}/merchants/soundbox-devices/payments?status=${status}&offset=${offset}&limit=${limit}`,
  );
}

const exclusiveQris = secureClient(
  {
    retrieveUserInfo,
    retrieveDeviceInfo,
    retrieveQrisSoundBoxTransactionSummaries,
    retrieveQrisSoundBoxPayments,
  },
  'xhrExclusiveQrisApi',
);

export default exclusiveQris;
